import BaseModel from "../BaseModel";
import Contact from "./Contact";

export default class PhoneNumber extends BaseModel{
	static entity = 'numbers';
	static fields(){
		return {
			id: this.attr(null),
			contact_id: this.attr(null),
			number: this.attr(null),
			ext: this.attr(null),
			contact: this.belongsTo(Contact, 'contact_id'),
			user_id: this.attr(null),
			deleted_at: this.attr(null),
		}
	}
	static ignoredLogFields(){
		return ['created_at', 'updated_at', 'contact']
	}
	static route(){
		return '/contacts/numbers'
	}
}